<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Purchase",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect, Loader },
  data() {
    return {
      title: "Add to store",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Purchase",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      existingItem: [],
      unitsArr: [],

      // Value from user input for adding position
      data: {
        source: 0,
        product: "",
        unit: "",
        quantity: "",
        unit_price: "",
        batch: "",
        expiry: "",
        category: 0,
        manufacture_date: "",
        product_code: [],
      },
      itemError: "",
      quantityError: "",
      unitError: "",
      CreditLimitError: "",
      unit_priceError: "",
      batch_noError: "",
      expiry_dateError: "",
      manufacture_dateError: "",
      totals: {
        paid: 0,
        total: "",
        supplier: "",
        mode: "",
        discount: 0,
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        quantity: "",
        batch: "",
        expiry: "",
        unit_price: "",
        manufacture_date: "",
      },
      deposits: 0,
      limit: 0,
      editsup: {
        sup_id: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      modeError: "",
      supError: "",
      paidError: "",
      BuyingPrice: "",
      product_codes: [""],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapState("store", ["total_store_cart", "purchaseId"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("store", [
      "SaveStatus",
      "StoreCart",
      "TotalStoreCart",
      "StorePdts",
    ]),
    ...mapGetters("setting", [
      "PaymentOptions",
      "ReceiptSettings",
      "GeneralSettings",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("stock", ["SupplierDeposits","Suppliers"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product_name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_field",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL PRICE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ];

      if (this.GeneralSettings && this.GeneralSettings.track_expiries == 1) {
        baseFields.splice(
          4,
          0,
          {
            key: "batch",
            sortable: true,
            label: "BATCH",
          },
          {
            key: "expiry",
            sortable: true,
            label: "EXPIRY",
          },
          {
            key: "manufacture_date",
            sortable: true,
            label: "MANUFACTURED DATE",
          },
        );
      }

      if (
        this.GeneralSettings &&
        this.GeneralSettings.allow_multiple_productcodes == 1
      ) {
        baseFields.splice(5, 0, {
          key: "product_code",
          sortable: true,
          label: "PRODUCT CODE(S)",
        });
      }
      return baseFields;
    },

    rows() {
      return this.StoreCart ? this.StoreCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },

  mounted() {
    this.totals.paid = this.TotalStoreCart;
    this.totals.total = this.TotalStoreCart;
    // Set the initial number of items
    this.totalRows = this.StoreCart ? this.StoreCart.length : 1;
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    total_store_cart(newValue) {
      if (newValue) {
        this.totals.paid = this.thousandSeprator(this.TotalStoreCart);
      }
    },
    PaymentOptions(newValue) {
      if (newValue) {
        this.setDefaultMode();
      }
    },
    purchaseId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_purchase == 1) {
        window.open(
          `https://${
            window.location.host
          }/receipts/purchasesreceipt.php?id=${btoa(newValue)}`,
        );
      }
    },
  },

  methods: {
    ...mapActions({
      FetchCart: "store/fetchStoreCart",
      FetchItems: "products/fetchProducts",
      FetchSuppliers: "stock/fetchSuppliers",
      AddCart: "store/addToStoreCart",
      DeleteCartItem: "store/deleteStoreCart",
      FetchTotal: "store/fetchTotStoreCart",
      EditCartItems: "store/editStoreCart",
      SavePurchasePrint: "store/savePurchasePrint",
      SavePurchaseExit: "store/savePurchaseExit",
      FetchModes: "setting/fetchPaymentOptions",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      ImportProducts: "store/import_products",
      FetchSupplierDeposits: "stock/fetchSupplierDeposits",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchStoreItems: "store/fetchStorePdts",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    paidCommas() {
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas() {
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },
    buyingCommas() {
      this.data.unit_price = this.thousandSeprator(this.data.unit_price);
    },
    editBuyingCommas() {
      this.editdata.unit_price = this.thousandSeprator(
        this.editdata.unit_price,
      );
    },

    assignArr() {
      let selectedPdt = this.Products.find(
        (product) => product.id === this.data.product,
      );
      if (selectedPdt) {
        this.BuyingPrice = selectedPdt.buying_price;
        this.unitsArr = selectedPdt.units;
        // Always reset the unit field to the first unit of the selected product
        this.data.unit =
          this.unitsArr && this.unitsArr.length > 0 ? this.unitsArr[0].id : "";
        this.data.unit_price =
          this.GeneralSettings.autofillprices_onstocking == 1
            ? selectedPdt.buying_price
            : "";
      } else {
        this.unitsArr = [];
        this.data.unit = "";
      }
    },
    setDefaultMode() {
      let defaultop = this.PaymentOptions
        ? this.PaymentOptions
        : [].filter((mode) => {
            return mode.default == 1;
          });
      this.totals.mode = defaultop[0] ? defaultop[0].id : 0;
    },

    checkItem() {
      if (this.data.product != "") {
        this.existingItem = this.StoreCart.filter((item) => {
          return item.product.id == this.data.product;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.product = "";
      this.data.unit = "";
      this.data.unit_price = "";
      this.data.batch = "";
      this.data.expiry = "";
      this.data.quantity = "";
      this.data.manufacture_date = "";
      this.product_code = [];
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEditSup(modalId) {
      this.closeModal(modalId);
      this.editsup.sup_id = "";
      this.modal_id = "";
    },

    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.expiry = "";
      this.editdata.batch = "";
      this.editdata.unit_price = "";
      this.editdata.manufacture_date = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.unitError = "";
      this.CreditLimitError = "";
      this.quantityError = "";
      this.unit_priceError = "";
      this.batch_noError = "";
      this.expiry_dateError = "";
      this.manufacture_dateError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.product.id;
      this.editdata.name = data.product.product_name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.expiry = data.expiry;
      this.editdata.manufacture_date = data.manufacture_date;
      this.editdata.batch = data.batch;
      this.editdata.unit_price = this.thousandSeprator(data.unitprice);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.product.product_name;
      this.deletedata.id = data.id;
    },

    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
      this.focusProduct();
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
      this.focusProduct();
    },

    // Validate manufacture date if set
    validateManufactureDate() {
      // Reset error
      this.manufacture_dateError = "";

      if (this.data.manufacture_date) {
        // Check if it's a valid date
        const manufactureDate = new Date(this.data.manufacture_date);
        if (isNaN(manufactureDate.getTime())) {
          this.manufacture_dateError = "Please enter a valid manufacture date";
          return false;
        }

        // If expiry date is set, compare dates
        if (this.data.expiry) {
          const expiryDate = new Date(this.data.expiry);
          if (manufactureDate > expiryDate) {
            this.manufacture_dateError =
              "Manufacture date cannot be later than expiry date";
            return false;
          }
        }
      }

      return true;
    },

    savePurchasePrint() {
      let discount1 = this.totals.discount
        ? String(this.totals.discount).replaceAll(/,/g, "")
        : 0;
      if (
        this.GeneralSettings.enable_credit_limit == 1 &&
        this.totals.supplier != ""
      ) {
        let limit = 0;
        let deposits = 0;
        this.SupplierDeposits.forEach((item) => {
          if (item.supplier.id == this.totals.supplier) {
            limit = item.supplier.credit_limit;
            deposits = deposits + parseInt(item.amount);
          }
        });
        this.limit = limit;
        this.deposits = deposits;
        if (
          this.limit +
            this.deposits +
            parseInt(
              (this.totals.paid !== undefined && this.totals.paid !== null
                ? String(this.totals.paid)
                : "0"
              ).replaceAll(/,/g, ""),
            ) +
            discount1 <
          this.TotalStoreCart
        ) {
          this.CreditLimitError = "The Credit Limit Exceeded";
          return;
        } else {
          this.CreditLimitError = "";
          if (this.totals.mode == "") {
            this.modeError = "Payment Method is required";
            return;
          } else {
            this.modeError = "";
          }
          let paid1 = (
            this.totals.paid !== undefined && this.totals.paid !== null
              ? String(this.totals.paid)
              : "0"
          ).replaceAll(/,/g, "");
          let discount1 = this.totals.discount
            ? String(this.totals.discount).replaceAll(/,/g, "")
            : 0;
          let tt = parseFloat(paid1) + parseFloat(discount1);
          if (
            this.totals.supplier == "" &&
            (tt < this.totals.total || this.totals.paid == "")
          ) {
            this.supError = "Supplier is required";
            return;
          } else {
            this.supError = "";
          }
          if (this.totals.paid == "") {
            this.totals.paid = 0;
          }
        }
      }
      if (this.totals.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      let paid1 = (
        this.totals.paid !== undefined && this.totals.paid !== null
          ? String(this.totals.paid)
          : "0"
      ).replaceAll(/,/g, "");
      let tt = parseFloat(paid1) + parseFloat(discount1);
      if (
        this.totals.supplier == "" &&
        (tt < this.totals.total || this.totals.paid == "")
      ) {
        this.supError = "Supplier is required";
        return;
      } else {
        this.supError = "";
      }
      if (this.totals.paid == "") {
        this.totals.paid = 0;
      }
      this.SavePurchasePrint(this.totals);
    },

    savePurchaseExit() {
      let discount1 = this.totals.discount
        ? String(this.totals.discount).replaceAll(/,/g, "")
        : 0;
      if (
        this.GeneralSettings.enable_credit_limit == 1 &&
        this.totals.supplier != ""
      ) {
        let limit = 0;
        let deposits = 0;
        this.SupplierDeposits.forEach((item) => {
          if (item.supplier.id == this.totals.supplier) {
            limit = item.supplier.credit_limit;
            deposits = deposits + parseInt(item.amount);
          }
        });
        this.limit = limit;
        this.deposits = deposits;
        if (
          this.limit +
            this.deposits +
            parseInt(
              (this.totals.paid !== undefined && this.totals.paid !== null
                ? String(this.totals.paid)
                : "0"
              ).replaceAll(/,/g, ""),
            ) +
            discount1 <
          this.TotalStoreCart
        ) {
          this.CreditLimitError = "The Credit Limit Exceeded";
          return;
        } else {
          this.CreditLimitError = "";
        }
      }
      if (this.totals.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      let paid1 = this.totals.paid.replaceAll(/,/g, "");
      let tt = parseFloat(paid1) + parseFloat(discount1);
      if (this.totals.supplier == "" && tt < this.totals.total) {
        this.supError = "Supplier is required";
        return;
      } else {
        this.supError = "";
      }
      if (this.totals.paid == "") {
        this.totals.paid = 0;
      }
      this.SavePurchaseExit(this.totals);
      this.focusProduct();
    },

    resetmodeError() {
      this.modeError = "";
    },

    resetSupError() {
      this.supError = "";
    },

    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Purchased is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.data.unit_price == "") {
        this.unit_priceError = "Unit Price Field is required";
        return;
      } else {
        this.unit_priceError = "";
      }
      if (this.data.batch != "" && this.data.expiry == "") {
        this.expiry_dateError = "Expiry Date is required";
        return;
      } else {
        this.expiry_dateError = "";
      }
      if (!this.validateManufactureDate()) {
        return;
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
        this.BuyingPrice = "";
      }
      this.AddCart(this.data);
      this.resetData();
      this.focusProduct();
    },

    nextPlease() {
      document.getElementById("input2").focus();
    },

    focusPrice() {
      document.getElementById("input3").focus();
    },

    focusProduct() {
      // ModelListSelect does not expose .focus(), so focus the inner input
      if (this.$refs.cartProduct && this.$refs.cartProduct.$el) {
        const input = this.$refs.cartProduct.$el.querySelector("input");
        if (input) input.focus();
      }
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });
    },
    Import(modalId) {
      this.ImportProducts();
      this.closeModal(modalId);
    },
    FilterItems() {
      this.StoreItems = [];
      if (this.data.store != "") {
        let storeItems = this.StorePdts.filter((item) => {
          return item.store_id == this.data.store;
        });
        this.StoreItems = storeItems;
      }
    },
    checkAndAddField(index) {
      const lastIndex = this.product_codes.length - 1;
      // If current field has a value and it's the last field, add a new one
      if (index === lastIndex && this.product_codes[index].trim() !== "") {
        this.product_codes.push("");
      }
    },

    removeField(index) {
      this.product_codes.splice(index, 1);

      // Ensure at least one field remains
      if (this.product_codes.length === 0) {
        this.product_codes.push("");
      }
    },

    addCodes(modalId) {
      const codesArray = this.product_codes
        .map((code) => code.trim())
        .filter((code) => code !== "");
      this.data.product_code = codesArray;
      this.closeModal(modalId);
    },

    resetCodes() {
      this.product_codes = [""];
    },
    setInputRef(el, index) {
      if (!this.codeInputRefs) {
        this.codeInputRefs = {};
      }
      if (el) {
        this.codeInputRefs[index] = el;
      }
    },

    handleKey(index, event) {
      if (event.key === "Enter") {
        event.preventDefault();

        this.checkAndAddField(index);

        this.$nextTick(() => {
          this.$nextTick(() => {
            const nextInput = this.codeInputRefs[index + 1];
            if (nextInput && nextInput.focus) {
              nextInput.focus();
            }
          });
        });
      }
    },
  },

  created() {
    this.FetchSupplierDeposits();
    this.fetchReceiptSettings();
    this.FetchSuppliers();
    this.FetchItems();
    this.FetchCart();
    this.FetchTotal();
    this.FetchModes();
    this.FetchGeneralSettings();
    this.FetchStoreItems();
    setTimeout(() => {
      this.setDefaultMode();
    }, 3000);
  },
  updated() {
    this.totals.total = this.TotalStoreCart;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <b-button
              v-if="GeneralSettings.import_products == 1"
              v-b-modal.import-modal
              variant="warning"
              size="sm"
              >Import all Products</b-button
            >
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="StoreCart ? StoreCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(product_name)="data">
                  {{
                    data.item.product && data.item.product.product_name
                      ? data.item.product.product_name
                      : "N/A"
                  }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitprice && data.item.quantity
                      ? thousandSeprator(
                          data.item.unitprice * data.item.quantity,
                        )
                      : 0
                  }}
                </template>
                <template #cell(unit_price)="data">
                  {{
                    data.item.unitprice
                      ? thousandSeprator(data.item.unitprice)
                      : 0
                  }}
                </template>
                <template #cell(quantity_field)="data">
                  {{ data.item ? data.item.quantity : 0 }}
                  {{ data.item && data.item.unitsym ? data.item.unitsym : "" }}
                </template>
                <template #cell(batch)="data">
                  {{ data.item.batch }}
                </template>
                <template #cell(expiry)="data">
                  {{ data.item.expiry }}
                </template>
                <template #cell(manufacture_date)="data">
                  {{ data.item.manufacture_date }}
                </template>
                <template #cell(product_code)="data">
                  <div
                    v-if="
                      Array.isArray(data.item.product_code) &&
                      data.item.product_code.length
                    "
                  >
                    <div
                      v-for="(code, index) in data.item.product_code"
                      :key="index"
                    >
                      {{ code }}<br />
                    </div>
                  </div>
                  <div
                    v-else-if="
                      data.item.product && data.item.product.product_code
                    "
                  >
                    {{ data.item.product.product_code }}
                  </div>
                  <div v-else>N/A</div>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i
                  ></b-button>
                  <b-button
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i
                  ></b-button>
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!StoreCart" />
            <div class="row" v-if="TotalStoreCart > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                    >TOTAL:
                    {{
                      TotalStoreCart ? thousandSeprator(TotalStoreCart) : 0
                    }}/=</strong
                  >
                </h4>
              </div>
            </div>

            <b-form v-if="TotalStoreCart > 0" class="mt-3">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Amount Paid</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.paid"
                      @input="paidCommas()"
                      min="0"
                    />
                  </div>
                  <div class="text-danger" v-if="CreditLimitError">
                    <em>{{ CreditLimitError }}</em>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label
                      >Payment Method <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="totals.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Method"
                      @input="resetmodeError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Supplier <span class="text-danger">*</span></label>
                    <model-list-select
                      :list="Suppliers ? Suppliers : []"
                      v-model="totals.supplier"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Supplier"
                      @input="resetSupError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="supError">
                    <em>{{ supError }}</em>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-3">
                  <div class="form-group mb-3">
                    <label>Purchase Date</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                      v-limit-future-date
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Discount Received</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.discount"
                      @input="discountCommas()"
                      min="0"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    MyUserPerm.add_store_stock == 1 &&
                    ReceiptSettings.print_receipt_after_purchase == 1
                  "
                  class="col-md-3 mt-4"
                >
                  <b-button
                    variant="primary"
                    class="float-end"
                    v-if="SaveStatus"
                    disabled
                    ><i class="fa fa-check"></i> Save & Print
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                  <b-button
                    v-else
                    variant="primary"
                    class="float-end"
                    @click="savePurchasePrint()"
                    ><i class="fa fa-check"></i> Save & Print
                  </b-button>
                </div>
                <div
                  v-if="MyUserPerm.add_store_stock == 1"
                  class="col-md-3 mt-4"
                >
                  <b-button
                    variant="primary"
                    class="float-end"
                    v-if="SaveStatus"
                    disabled
                    ><i class="fa fa-check"></i> Save & Exit
                    <b-spinner
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                  <b-button
                    v-else
                    variant="primary"
                    class="float-end"
                    @click="savePurchaseExit()"
                    ><i class="fa fa-check"></i> Save & Exit
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">
              <div class="form-group mb-3">
                <label>Product <span class="text-danger">*</span></label>
                <model-list-select
                  id="input1"
                  class="form-control"
                  :list="Products ? Products : []"
                  v-model="data.product"
                  option-value="id"
                  option-text="name1"
                  placeholder="Select Product or Enter Barcode"
                  ref="cartProduct"
                  @input="resetErrors(), assignArr(), checkItem()"
                  @keyup.enter.native="nextPlease()"
                />
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>

              <div class="row">
                <h4 class="text-primary text-center" v-if="BuyingPrice">
                  Buying Price:<br />{{ thousandSeprator(BuyingPrice) }}
                </h4>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Quantity <span class="text-danger">*</span></label>
                    <input
                      type="number"
                      class="form-control"
                      step="any"
                      id="input2"
                      v-model="data.quantity"
                      @input="resetErrors()"
                      placeholder="Enter Quantity"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label
                      >Unit Measure <span class="text-danger">*</span></label
                    >
                    <model-list-select
                      :list="unitsArr ? unitsArr : []"
                      v-model="data.unit"
                      option-value="id"
                      option-text="unitname"
                      placeholder="Select Unit"
                      @input="resetErrors()"
                      @keyup.enter="focusPrice()"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-3">
                <label
                  >Unit Buying Price <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  step="any"
                  id="input3"
                  v-model="data.unit_price"
                  @input="resetErrors(), buyingCommas()"
                  placeholder="Enter Unit Buying Price"
                />
                <div class="text-danger" v-if="unit_priceError">
                  <em>{{ unit_priceError }}</em>
                </div>
              </div>
              <div
                v-if="GeneralSettings.allow_multiple_productcodes == 1"
                class="form-group mb-3"
              >
                <label
                  >Product Code(s)
                  <span>
                    <b-button
                      size="sm"
                      style="font-size: 20px"
                      variant="link"
                      v-b-modal.add-code-modal
                    >
                      New
                    </b-button>
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.product_code"
                  @input="resetErrors()"
                  placeholder="Enter Product code"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="batch_noError">
                  <em>{{ batch_noError }}</em>
                </div>
              </div>
              <div
                v-if="GeneralSettings.track_expiries == 1"
                class="form-group mb-3"
              >
                <label>Batch Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.batch"
                  @input="resetErrors()"
                  placeholder="Enter Batch Number"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="batch_noError">
                  <em>{{ batch_noError }}</em>
                </div>
              </div>
              <div
                v-if="GeneralSettings.track_expiries == 1"
                class="form-group mb-3"
              >
                <label>Manufactured Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="data.manufacture_date"
                  @input="resetErrors()"
                  @keyup.enter="addToCart()"
                  v-limit-future-date
                />
                <div class="text-danger" v-if="manufacture_dateError">
                  <em>{{ manufacture_dateError }}</em>
                </div>
              </div>
              <div
                v-if="GeneralSettings.track_expiries == 1"
                class="form-group mb-3"
              >
                <label
                  >Expiry Date
                  <span v-if="data.batch != ''" class="text-danger"
                    >*</span
                  ></label
                >
                <input
                  type="date"
                  class="form-control"
                  v-model="data.expiry"
                  @input="resetErrors()"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="expiry_dateError">
                  <em>{{ expiry_dateError }}</em>
                </div>
              </div>
              <div class="form-group text-center">
                <b-button @click="addToCart()" variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal
      id="edit-item-modal"
      class="text-primary"
      hide-footer
      @hidden="resetEdit()"
    >
      <template #modal-title> Edit Item {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Buying Price</label>
        <input
          type="text"
          class="form-control"
          step="any"
          v-model="editdata.unit_price"
          @input="editBuyingCommas()"
        />
      </div>
      <div class="form-group mb-3">
        <label>Batch Number</label>
        <input type="text" class="form-control" v-model="editdata.batch" />
      </div>
      <div v-if="GeneralSettings.track_expiries == 1" class="form-group mb-3">
        <label>Manufactured Date</label>
        <input
          type="date"
          class="form-control"
          v-model="editdata.manufacture_date"
          v-limit-future-date
        />
      </div>
      <div class="form-group mb-3">
        <label>Expiry Date</label>
        <input type="date" class="form-control" v-model="editdata.expiry" />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal
      id="delete-item-modal"
      class="text-danger"
      hide-footer
      @hidden="resetDeleteItem"
    >
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete category starts -->
    <b-modal
      header-bg-variant="warning"
      header-text-variant="light"
      body-text-variant="warning"
      footer-bg-variant="warning"
      footer-text-variant="warning"
      id="import-modal"
      hide-footer
    >
      <template #modal-title> Import all Products </template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            You are importing all products to store? Click Proceed Button to
            import.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('import-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="Import('import-modal')"
        >
          Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Importing"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- product codes modal starts-->
    <b-modal
      id="add-code-modal"
      hide-footer
      @hidden="resetCodes"
      :backdrop="'static'"
    >
      <template #modal-title> Add Product Codes </template>

      <div
        v-for="(code, index) in product_codes"
        :key="index"
        class="input-group mb-2"
      >
        <input
          v-model="product_codes[index]"
          @input="checkAndAddField(index)"
          @keydown="handleKey(index, $event)"
          class="form-control"
          :ref="(el) => setInputRef(el, index)"
        />
        <div class="input-group-append" v-if="product_codes.length > 1">
          <button
            class="btn btn-outline-danger"
            type="button"
            @click="removeField(index)"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-code-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary">
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            disabled
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addCodes('add-code-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- product codes modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
